import MarkdownToJsx from 'markdown-to-jsx'
import PropTypes from 'prop-types'
import React from 'react'

import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'

const defaultOptions = {
  overrides: {
    h1: {
      component: Typography,
      props: {
        align: 'justify',
        component: 'span',
        gutterBottom: true,
        paragraph: true,
        variant: 'h4',
      },
    },
    h2: {
      component: Typography,
      props: {
        align: 'justify',
        component: 'span',
        gutterBottom: true,
        paragraph: true,
        variant: 'h5',
      },
    },
    h3: {
      component: Typography,
      props: {
        align: 'justify',
        component: 'span',
        gutterBottom: true,
        paragraph: true,
        variant: 'h6',
      },
    },
    p: {
      component: Typography,
      props: {
        align: 'justify',
        paragraph: true,
        variant: 'body2',
      },
    },
    a: {
      component: Link,
      props: {
        target: '_blank',
      },
    },
    pre: {
      component: 'span',
    },
    code: {
      component: 'span',
    },
  },
}

export default function Markdown(props) {
  const { options = defaultOptions } = props

  return <MarkdownToJsx options={options} {...props} />
}

Markdown.propTypes = {
  options: PropTypes.objectOf(PropTypes.any),
}
